import {
    INVENTORY_FETCH_SLUGS_FAILURE,
    INVENTORY_FETCH_SLUGS_START,
    INVENTORY_FETCH_SLUGS_SUCCESS
} from '../../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    loaded: false,
    error: null,
    data: null,
};

export function slugsReducer(state = INITIAL_STATE, action){
    switch (action.type) {
        case INVENTORY_FETCH_SLUGS_START:
            return { loading: true, loaded: false, error: null, data: state.data };
        case INVENTORY_FETCH_SLUGS_SUCCESS:
            return { loading: false, loaded: true, error: null, data: action.payload };
        case INVENTORY_FETCH_SLUGS_FAILURE:
            return {
                loading: false,
                loaded: true,
                error: action.error,
                data: state.data
            };
        default:
            return state;
    }
}